import {
  adminInput,
  adminButtonPrimary,
  adminSectionTitle,
  adminModalPanel,
} from '../../../layout/adminStyles';
import React, { FC, FormEvent } from 'react';
import { TweetForm } from './tweetForm';

type Props = {
  isShowModal: boolean;
  form: TweetForm;
  isSaving: boolean;
  onChange: (form: TweetForm) => void;
  onClose: () => void;
  onSubmit: () => void;
};

const TweetEditModal: FC<Props> = ({
  isShowModal,
  form,
  isSaving,
  onChange,
  onClose,
  onSubmit,
}) => {
  if (!isShowModal) {
    return null;
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tweet-edit-modal-title"
    >
      <div className={adminModalPanel}>
        <div className="mb-4 flex items-center justify-between border-b border-stone-200 pb-3">
          <h2 id="tweet-edit-modal-title" className={adminSectionTitle + ' mb-0 border-0 pb-0'}>
            つぶやきを編集
          </h2>
          <button
            type="button"
            className="text-2xl leading-none text-stone-500 hover:text-stone-800"
            onClick={onClose}
            aria-label="閉じる"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="edit-tweet-body" className="mb-1 block text-sm font-medium text-stone-700">
              つぶやき
            </label>
            <textarea
              id="edit-tweet-body"
              required
              rows={4}
              maxLength={500}
              className={`${adminInput} w-full resize-y`}
              value={form.body}
              onChange={(e) => onChange({ ...form, body: e.target.value })}
            />
            <p className="mt-1 text-right text-xs text-stone-500">{form.body.length}/500</p>
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="rounded-xl border border-stone-300 px-5 py-2 text-stone-700 hover:bg-stone-50"
              onClick={onClose}
              disabled={isSaving}
            >
              キャンセル
            </button>
            <button type="submit" className={adminButtonPrimary} disabled={isSaving}>
              {isSaving ? '保存中...' : '保存'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TweetEditModal;
